// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReCaptchaTerms_wrapper__GOyDW","copy":"ReCaptchaTerms_copy__mOrEo","link":"ReCaptchaTerms_link__12uTg"};